import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import {
  Avatar,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../../../../components/Modal";
import color from "../../../../constants/color";
import styles from "./style";
import { formatDate } from "../../../../utils/DateFormat";

const PayrollSalaryListPage = ({ salaryData, payrollData }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleNavigate = (item) => {
    navigate("/dashboard/payrollPayslips", { state: { item, payrollData } });
  };

  return (
    <>
      <TableContainer sx={styles.card}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Name</TableCell>
              <TableCell sx={styles.TableHead}>Gross Income</TableCell>
              <TableCell sx={styles.TableHead}>Net Pay</TableCell>
              <TableCell sx={styles.TableHead}>Salary</TableCell>
              <TableCell sx={styles.TableHead}>From</TableCell>
              <TableCell sx={styles.TableHead}>To</TableCell>
              <TableCell sx={styles.TableHead}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {salaryData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="h6">No Data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              salaryData?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ ...styles.tableAlign, ...styles.tableData }}>
                    <Avatar
                      src={item?.employee?.personalInfo?.image}
                      sx={{ mr: "8px" }}
                    />
                    <Box>
                      <Typography sx={styles.name}>
                        {" "}
                        {`${item?.employee?.personalInfo?.firstName} ${item?.employee?.personalInfo?.surName}`}
                      </Typography>
                      <Typography sx={styles.mail}>
                        {item?.employee?.personalInfo?.email}
                      </Typography>
                    </Box>{" "}
                  </TableCell>
                  <TableCell sx={styles.tableData}>
                    {" "}
                    <Typography sx={{ ...styles.name }}>
                      {item?.grossInc}
                    </Typography>
                  </TableCell>
                  <TableCell sx={styles.tableData}>
                    {" "}
                    <Typography sx={{ ...styles.name }}>
                      {item?.netPay}
                    </Typography>
                  </TableCell>
                  <TableCell sx={styles.tableData}>
                    {" "}
                    <Typography sx={{ ...styles.name }}>
                      {item?.basicSalary}
                    </Typography>
                  </TableCell>
                  <TableCell sx={styles.tableData}>
                    {" "}
                    <Typography sx={{ ...styles.name }}>
                      {formatDate(item?.from)}
                    </Typography>
                  </TableCell>
                  <TableCell sx={styles.tableData}>
                    {" "}
                    <Typography sx={{ ...styles.name }}>
                      {formatDate(item?.to)}
                    </Typography>
                  </TableCell>
                  <TableCell sx={styles.tableData}>
                    <Box sx={styles.tableIcon}>
                      <RemoveRedEyeOutlinedIcon
                        sx={{ color: color.lightText, mx: 2 }}
                        onClick={() => {
                          handleNavigate(item);
                        }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Modal
        open={open}
        setOpen={setOpen}
        deletetText={"Delete"}
        cancelText={"Cancel"}
        title={"Delete Employee"}
      >
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>{" "}
    </>
  );
};
export default PayrollSalaryListPage;
